import { Outlet } from 'react-router-dom';
import React from 'react';
import { Spin, Layout} from 'antd';
import {  useSelector } from 'react-redux';

function RootLayout() {
    const appUiState = useSelector((state: any) => state.portal.uiState);
    return (
        <Layout className="layout" data-testid="root-layout">
            <Spin spinning={appUiState.isAppLoading} fullscreen />
            <Outlet />
        </Layout>
    );
}

export default RootLayout;
